import * as style from './styles.css';

interface IContentProps {
  motivationTop?: JSX.Element;
  button?: JSX.Element;
  motivationBottom?: JSX.Element;
  advantages?: JSX.Element;
}

export const Content: React.FC<IContentProps> = ({ motivationTop, button, advantages, motivationBottom }) => {
  return (
    <div className={style['container']}>
      {motivationTop}
      {button}
      {advantages}
      {motivationBottom}
    </div>
  );
};
